import ChevronDown24 from './ChevronDown24';
import ChevronDown16 from './ChevronDown16';
type Props = {
  size?: 16 | 24;
  color?: string;
  [key: string]: any;
};

const assets = {
  24: ChevronDown24,
  16: ChevronDown16,
};

export default ({ size = 16, color, ...args }: Props) => {
  const Asset = assets[size];
  return (
    <span className="oksoon-icon oksoon-icon--ChevronDown" {...args}>
      <Asset color={color} />
    </span>
  );
};
